import React from 'react';

import RondaMark from '../assets/ronda/ronda-mark.png';
import { useLanguage } from '../i18n';

const Logo = ({ className = '', inverted = false }) => {
  const { t } = useLanguage();

  return (
    <a
      href='#top'
      className={`inline-flex min-h-[44px] items-center gap-2.5 ${className}`}
      aria-label={t.logoLabel}
    >
      <img
        src={RondaMark}
        alt=''
        width='40'
        height='40'
        className={`h-10 w-10 ${inverted ? 'brightness-0 invert' : ''}`}
      />
      <span
        className={`font-display text-[22px] font-semibold tracking-title ${
          inverted ? 'text-white' : 'text-ink'
        }`}
      >
        Ronda
      </span>
    </a>
  );
};

export default Logo;
